module.exports = __webpack_public_path__ + "img/logo.e503f0ad.svg";